import notification from '@atoms/Notification';

import useResourceList from './useResourceList';
import useQuery from './useQuery';
import useMutation from './useMutation';

import api from '..';

export const useCompetitionsList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'competitions', api: api.competitions }, queryVariables, queryConfig);

  return {
    competitions: queryResult.resolvedData,
    latestCompetitions: queryResult.latestData,
    ...queryResult,
  };
};

export const useCompetition = ({ id }, queryConfig = {}) => {
  const queryResult = useQuery(['competition', { id }], api.competitions.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    competition: queryResult.data || {},
    ...queryResult,
  };
};

// FIXME: Ad hoc solution while legacy event's in db don't have proper connection with competitions by id
export const useCompetitionByUrlSlug = ({ urlSlug }, queryConfig = {}) => {
  const queryResult = useCompetitionsList({ urlSlug }, queryConfig);

  const competition = queryResult.competitions?.data?.[0];
  return {
    ...queryResult,
    competition: competition || {},
    data: competition,
  };
};

export const useCompetitionsByIds = (ids, queryConfig = {}) => {
  const queryResult = useQuery(['competitions', { ids }], api.competitions.getByIds, {
    ...queryConfig,
    enabled: ids?.length > 0,
  });

  return {
    competitions: queryResult.data || [],
    ...queryResult,
  };
};

export const useGetCompetitionAppearance = ({ id }, queryConfig = {}) => {
  const queryResult = useQuery(['competitions', { id }], api.competitions.getAppearance, {
    onError: (error) => {
      if (error?.response?.status !== 404) {
        notification.error({ message: error.message });
      }
    },
    ...queryConfig,
  });

  return {
    appearance: queryResult.data || {},
    ...queryResult,
  };
};

const createAppearanceMutation = (apiCall) => (queryConfig = {}) =>
  useMutation(apiCall, {
    onSuccess: () => notification.success({ message: 'Successfully saved appearance ' }),
    onError: () => notification.error({ message: 'Failed to save appearance' }),
    ...queryConfig,
  });

export const useCreateCompetitionAppearance = createAppearanceMutation(api.competitions.createAppearance);
export const useUpdateCompetitionAppearance = createAppearanceMutation(api.competitions.updateAppearance);
export const useUpsertCompetitionAppearance = createAppearanceMutation(api.competitions.upsertAppearance);
